// The public API key for Double the Donation
// Used for the Double the Donation integration on code.org/donate
// See: https://support.doublethedonation.com/knowledge/getting-started-understanding-api-keys
export const DOUBLE_THE_DONATION_PUBLIC_KEY = '4RoxGGsUoWBRMUfj';
